module.exports = __webpack_public_path__ + "img/accountlinking-aut.70b13bae.png";